import React from "react";
import { GetStaticProps } from "next";
import { TermsOfServiceData } from "@components/CMSPage";
import CmsPageContainer, {
  TCmsPageContainer,
} from "@components/CMSPage/CmsPageContainer";

const TosPage: React.FC<TCmsPageContainer> = (pageData: TCmsPageContainer) => {
  return <CmsPageContainer {...pageData} />;
};

export const getStaticProps: GetStaticProps = async () => {
  const tosData: TCmsPageContainer = TermsOfServiceData;
  return {
    props: {
      ...tosData,
    },
  };
};

export default TosPage;
